// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"500b765a","445":"2857af88","453":"d855a71b","621":"373688b3","776":"60a957fa"}[chunkId] + ".chunk.js";
};